var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-input',{attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_c('i',{staticClass:"fa fa-times"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }